// Beat → bubble content resolver. Plain function so subjects can swap in
// custom framing later (e.g. Deutsch reading-comp: "Lies nochmal genau…")
// without editing the bubble component.

export type Beat = 'render' | 'correct' | 'incorrect' | 'idle';

export interface CalloutContent {
  text: string;
  kind: 'dialogue' | 'hint' | 'feedback';
}

export interface CalloutSourceArgs {
  dialogue: string;
  hints: string[];
  correctFeedback: string;
  incorrectFeedback: string;
  beat: Beat;
  hintTier: number;        // -1 = dialogue, 0..hints.length-1 = hint tier
}

export function resolveCallout(args: CalloutSourceArgs): CalloutContent {
  const { beat, hintTier, dialogue, hints, correctFeedback, incorrectFeedback } = args;

  if (beat === 'correct') {
    return { text: correctFeedback || dialogue || '', kind: 'feedback' };
  }
  if (beat === 'incorrect') {
    return { text: incorrectFeedback || dialogue || '', kind: 'feedback' };
  }
  if (hintTier >= 0 && hints[hintTier]) {
    return { text: hints[hintTier], kind: 'hint' };
  }
  return { text: dialogue || '', kind: 'dialogue' };
}
